export default __webpack_public_path__ + "static/media/gridImage12.cd79e244.png";